<template>
  <FontType />
  <Input
    id="primaryText"
    :placeholder="defaultPrimaryText"
    classes="col-12"
    :label="$t('Add text')"
    name="primaryText"
    rules="required"
    :value="product.attributes.primaryText"
    @updated-value="updatedInputField"
  />
  <div class="attribute-group form-group col-12 radio-container">
    <input
      id="secondaryTextRadio"
      v-model="showSecondaryText"
      type="checkbox"
      name="secondaryTextRadio"
      @change="toggleSecondaryText"
    >
    <div class="text">
      <label for="secondaryTextRadio">{{ $t("Add secondary text") }}</label>
    </div>
  </div>
  <Input
    v-if="showSecondaryText"
    id="secondaryText"
    type="textarea"
    classes="col-12"
    maxlength="150"
    rows="3"
    :placeholder="secondaryTextPlaceholder"
    name="secondaryText"
    :value="product.attributes.secondaryText"
    @updated-value="updatedInputField"
  />
</template>
<script>
import { mapGetters } from 'vuex'
import useProduct from '../../useProduct'
import useCustom from '../../useCustom'
import FontType from '../custom/FontType'
import Input from '../Input.vue'

export default {
  components: {
    Input,
    FontType,
  },
  computed: {
    ...mapGetters('product', {
      product: 'getProduct',
      showSecondaryText: 'getShowSecondaryText',
    }),
  },
  setup() {
    const { updatedInputField } = useProduct()
    const {
      defaultPrimaryText,
      secondaryTextPlaceholder,
      toggleSecondaryText,
    } = useCustom()

    return {
      updatedInputField,
      defaultPrimaryText,
      secondaryTextPlaceholder,
      toggleSecondaryText,
    }
  },
}
</script>
